// src/services/dataService.js
import { apiRequest } from '../api/client';
import { endpoints } from '../api/endpoints';

export function sendDataToBackend(payload) {
    return apiRequest(endpoints.submitData, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    });
}

export function getDataById(id) {
    return apiRequest(endpoints.getExperimentData(id));
}

export function getSubmissionById(id) {
    return apiRequest(endpoints.getSubmissionData(id));
}

export function updateData(id, payload) {
    return apiRequest(endpoints.updateExperiment(id), {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    });
}

/** Deletes the contribution's runs that are not published; approved runs stay. */
export function withdrawSubmission(id) {
    return apiRequest(endpoints.withdrawSubmission(id), { method: 'DELETE' });
}

export function getMySubmissions() {
    return apiRequest(endpoints.mySubmissions);
}
